<template>
  <button class="component wm-button" :class="'wm-button--' + type"
          :style="sty" @click='jump'>
    {{ text }}
  </button>
</template>

<script>
  import {VueExtend} from 'godspen-lib'
  import props from './props'
  export default {
    mixins: [VueExtend.mixin, props],
    name: 'buisiness-button',
    label: process.env.LABEL,
    style: process.env.STYLE,
    computed: {
      ctext () {
        return this.scopeGet('text')
      },
      sty () {
        const obj = {
          color: this.color,
          'background-color': this.backgroundColor,
          'border-radius': this.isvalid(this.radius) ? `${this.radius}px` : '',
          'border-width': this.isvalid(this.border) ? `${this.border}px` : '',
          'font-size': this.isvalid(this.fontSize) ? `${this.fontSize}px` : '',
          'border-color': this.borderColor
        }
        const ACTSDK = window.ACTSDK
        if (this.type === 'channel' && ACTSDK) {
          const channels = ACTSDK.pageInfo.channels
          const platform = ACTSDK.platform
          // 小程序默认支持
          if (ACTSDK.isMiniProgram || channels.indexOf(platform) > -1) {
            obj['background-image'] = `url('${this.supportChannelBg}')`
          } else {
            obj['background-image'] = `url('${this.unSupportChannelBg}')`
          }
          obj['background-size'] = '100% 100%'
        }
        return obj
      }
    },
    methods: {
      jump () {
        if (this.eventType === 10) {
          this.weakUpMini();
        } else {
          const url = this.getUrl(this.handleUrl())
          console.log('url>>>>', url)
          const isLishengMini = window.ACTSDK.platform === 'wx_mini' && window.location.href.indexOf('xcx=RADISSONYD') > -1;
          if (isLishengMini) {
              window.wx.miniProgram.navigateTo({url: '/project/home/views/webview/index?url=' + encodeURIComponent(url)});
          } else {
            window.ACTSDK.open(url, this.isIgnoreChannel)
          }
        }
      },
      isvalid (val) {
        return (val || val === 0)
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" type="text/stylus" scoped>
  .component {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    -webkit-box-align: center;
    -webkit-box-pack: center;
    border-style: solid;
    -webkit-tap-highlight-color transparent
  }
  .wm-button {
    display: inline-block;
    line-height: 1;
    white-space: nowrap;
    cursor: pointer;
    box-sizing: border-box;
    border-style: solid;
    text-align: center;
    outline: none;
    border-radius: 4px;
    font-size: 14px;

    /* type: primary / success / warning / danger / text*/
    &--default {
      background-color: rgba(0, 0, 0, 0);
      border: 1px solid #5a5a5a;
      color: #5a5a5a;
    }
    &--primary {
      background-color: #409eff;
      border: 1px solid #409eff;
      color: #fff
    }
    &--success {
      background-color: #06b788;
      border: 1px solid #06b788;
      color: #fff;
    }
    &--warning {
      background-color: #F5AB3F;
      border: 1px solid #F5AB3F;
      color: #fff;
    }
    &--danger {
      background-color: #ef4f4f;
      border: 1px solid #ef4f4f;
      color: #fff;
    }
    &--text {
      background-color: rgba(0, 0, 0, 0);
      border: 0px solid #409eff;
      color: #409eff;
    }
    &--transparent {
      background-color: transparent;
      border: 0px solid #409eff;
    }
    &--channel {
      background-color: transparent;
      border: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/index.vue